<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="submenu-panel" id="sideOverlay{{menuItem?.type}}" *ngIf="selectedSubType && menuItem?.tabSupported && filteredTabs?.length > 0">
    <div class="search-locomotive">
        <lms-search-panel [parentName]='"sideNav"' [type]='menuItem.type' [indexOfTab]='tabsIndex + 1' (autoCompleteNotify)='onAutoCompleteNotify($event)'
            [searchText]="searchText" (searchValueChanged)="updateSearchText($event)"></lms-search-panel>
        <span class="loco-status-sidemenu" *ngIf="menuItem?.type == 'Query-View' || menuItem?.type == 'Locomotive-Status'">Click + to add new tab</span>
        <div *ngIf="selectedSubType && menuItem?.type != 'Outlying-Points' && menuItem?.type != 'Query-View' && menuItem?.type != 'Yard-Local' && menuItem?.type != 'Locomotive-Status'"
            class="submenu-dropdown">
            <p-dropdown [panelStyleClass]="'dialog-dropdown'" [options]="subTypes" [tabindex]="tabsIndex + 3" [(ngModel)]='selectedSubType' (onChange)='addNewTab($event);'>
                <ng-template let-subType pTemplate="subType">
                    <div class="p-helper-clearfix">
                        <div> {{subType.label}} </div>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
        <div class="yard-local-page-label" *ngIf="menuItem?.type == 'Yard-Local'">
            <div class="side-div-stations">
                <p-dropdown [panelStyleClass]="'dialog-dropdown'" [inputId]='"yardAndLocalDropDownsideNav"' [tabindex]='tabsIndex + 1' styleClass="p-dropdown" [options]="divisionList" 
                    [filter]="true" #selectedDivSideNav (onChange)='selectedDivSideNav.resetFilter(); changeDivision()' (onFocus)="selectedDivSideNav.resetFilter(); divisionListFocus()"
                    [(ngModel)]="selectedDivisionName">
                </p-dropdown>
            </div>
            <!-- <div class="side-alloc-stations">
                <lms-lms-dropdown [inputId]='"yardLocalStationDropDownsideNav"' [options]="stationList" [tabindex]='tabsIndex + 3' [filter]="true"
                    [disabled]="selectedDivisionName ? false : true" #selectedStatSideNav (onFocus)="selectedStatSideNav.resetFilter(); stationListFocus();"
                    (onChange)='selectedStatSideNav.resetFilter();addNewTab($event);' [(ngModel)]='selectedStationName' autoWidth="true">
                </lms-lms-dropdown>
            </div> -->
        </div>
        <div *ngIf="menuItem?.type !== 'Yard-Local'" id="navpanelOverlayBtn{{menuItem.type}}" class="add-terminal-icon" tabindex='{{tabsIndex + 8}}' (click)="addTab(true)" (keydown.space)='$event.preventDefault();'
            (keyup.space)='addTab(true)' (keydown.spacebar)='$event.preventDefault();' (keyup.spacebar)='addTab(true)'>
            <i class="fa fa-plus"></i>
        </div>
    </div>

    <div class="opened-tabs noselect">
        <ul>
            <li *ngFor="let tab of filteredTabs; let i = index;" [ngClass]="tab.selected ?'selected-tab':null">
                <a *ngIf="menuItem?.type != 'Outlying-Points'" href="javascript:void(0)" id='leftTab{{tab.id}}' tabindex='{{tabsIndex + i*2 + 10}}'
                    (click)="selectTab(tab, $event)" (keydown.space)='$event.preventDefault();' (keyup.space)='selectTab(tab, $event);  this.focus();'
                    (keydown.spacebar)='$event.preventDefault();' (keyup.spacebar)='selectTab(tab, $event);  this.focus();'>{{tab.description}}</a>
                <a *ngIf="menuItem?.type == 'Outlying-Points'" href="javascript:void(0)" id='leftTab{{tab.id}}' tabindex='{{tabsIndex + i*2 + 10}}'
                    (click)="selectTab(tab, $event)" (keydown.space)='$event.preventDefault();' (keyup.space)='selectTab(tab, $event);  this.focus();'
                    (keydown.spacebar)='$event.preventDefault();' (keyup.spacebar)='selectTab(tab, $event);  this.focus();'>{{appUtilityService.showDeskName(tab) ? appUtilityService.showDeskName(tab) : 'NEW TAB'}}</a>
                <i class="fa fa-times" tabindex='{{tabsIndex + i*2 + 11}}' (click)='removeTab(tab, $event)' (keydown.space)='$event.preventDefault();'
                    (keyup.space)='removeTab(tab, $event); this.focus();' (keydown.spacebar)='$event.preventDefault();' (keyup.spacebar)='removeTab(tab, $event); this.focus();'></i>
            </li>
        </ul>
    </div>
</div>